import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import React from "react";

interface ChartProps {
    id: number;
    title: string;
    height: number;
}

const VelocityPie = ({ id, title, height = 345 }: ChartProps) => {
    const [velocityPie, setVelocityPie] = React.useState<any[]>([]);
    const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`/dashboard/velocity/${id}/?entity_id=${localStorage.getItem('entity_id')}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setVelocityPie(Array.isArray(data.velocity) ? data.velocity : []);
            } catch (err) {
                console.log(err);     
            } finally {}
        };
        fetchData();

        const handleResize = () => {
        if (chartComponentRef.current && chartComponentRef.current.chart) {
                chartComponentRef.current.chart.reflow();
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const options: Highcharts.Options = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
        },
        title: {
            text: title,
            align: 'left'
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: [{
                    enabled: true,
                    distance: 20
                },{
                    enabled: true,
                    distance: -40,
                    format: '{point.percentage:.2f}%'
                }],
                showInLegend: true
            }
        },
        series: [
            {
                type: 'pie',
                name: 'Velocity',
                data: velocityPie
            }
        ]
    }

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                allowChartUpdate={true}
                exportEnabled={true}
                ref={chartComponentRef}
                containerProps={{ style: { width: '100% !important', height: height, borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
            />
        </div>
    );
};

export default VelocityPie;